import { type FetchPaymentTopupLobbyParams } from '@capsicum/common';

import { useTopUpRatesAndLimitsQuery } from '../data-access';

export const useTopUpRatesAndLimits = (params: FetchPaymentTopupLobbyParams) => {
	return useTopUpRatesAndLimitsQuery(params);
};
